<label>{{ 'DATA_PORTAL.EXPORT.HINT' | translate}}</label>
<p-dropdown
  [options]="yearOptions"
  [(ngModel)]="selectedYear">
</p-dropdown>

<div [ngSwitch]="entityLevel">
  <div *ngSwitchCase="searchEntityLevels.ORGANIZATION">
    <button (click)="export()"
            label="{{ BUTTON_PREFIX + 'ORGANIZATION' | translate}}"
            pButton
            tooltipPosition="bottom"
            type="button">
    </button>
  </div>
  <div *ngSwitchCase="searchEntityLevels.REGION">
    <button (click)="export()"
            label="{{ BUTTON_PREFIX + 'REGION' | translate}}"
            pButton
            tooltipPosition="bottom"
            type="button">
    </button>
  </div>
  <div *ngSwitchCase="searchEntityLevels.WORLD">
    <button (click)="export()"
            label="{{ BUTTON_PREFIX + 'WORLD' | translate}}"
            pButton
            tooltipPosition="bottom"
            type="button">
    </button>
  </div>
</div>
<p-blockUI [blocked]="block">
  <div class="wrapper">
    <h4>{{ 'DATA_PORTAL.EXPORT.LOADING' | translate }}</h4>
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</p-blockUI>
